import { render, staticRenderFns } from "./CustomerLayout.vue?vue&type=template&id=1c3b572f&scoped=true"
import script from "./CustomerLayout.vue?vue&type=script&lang=js"
export * from "./CustomerLayout.vue?vue&type=script&lang=js"
import style0 from "./CustomerLayout.vue?vue&type=style&index=0&id=1c3b572f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3b572f",
  null
  
)

export default component.exports